var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 128 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notes"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Guides"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.876445,0,0,0.876445,-14.0797,80.6909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbols"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Thin-L"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.418,5.811L149.756,5.811C157.959,5.811 162.109,1.66 162.109,-6.543L162.109,-79.785C162.109,-87.988 157.959,-92.09 149.756,-92.09L28.418,-92.09C20.215,-92.09 16.064,-87.988 16.064,-79.785L16.064,-6.543C16.064,1.66 20.215,5.811 28.418,5.811ZM28.662,1.855C22.852,1.855 19.971,-0.928 19.971,-6.689L19.971,-79.59C19.971,-85.4 22.852,-88.184 28.662,-88.184L149.561,-88.184C155.322,-88.184 158.203,-85.4 158.203,-79.59L158.203,-6.689C158.203,-0.928 155.322,1.855 149.561,1.855L28.662,1.855ZM54.883,21.484L123.291,21.484C124.463,21.484 125.342,20.654 125.342,19.531C125.342,18.359 124.463,17.529 123.291,17.529L54.883,17.529C53.711,17.529 52.832,18.359 52.832,19.531C52.832,20.654 53.711,21.484 54.883,21.484Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.c5d3bceec0e4010efba532379d6389fd.svg";
export { ForwardRef as ReactComponent };